import * as Yup from "yup";
import { instance } from "@/api/apiInstances/apiInstance.js";
import {
  updatePassword,
  firstPasswordChange,
} from "@/api/apiRequests/myProfileApi.js";
import constructErrorMessageMixin from "@/mixins/constructErrorMessageMixin.js";

export default {
  mixins: [constructErrorMessageMixin],
  computed: {
    validationRules() {
      return {
        old_password: [
          {
            required: true,
            message: this.$t("old_password_required"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("new_password_required"),
            trigger: "blur",
          },
          { validator: this.validateNewPassword, trigger: "blur" },
        ],
        password_confirmation: [
          {
            required: true,
            message: this.$t("repeat_password_required"),
            trigger: "blur",
          },
          { validator: this.validateRepeatPassword, trigger: "blur" },
        ],
      };
    },
  },

  methods: {
    validateNewPassword(rule, value, callback) {
      if (value === this.form.old_password) {
        callback(new Error(this.$t("old_and_new_password_must_be_different")));
      } else {
        callback();
      }
    },
    validateRepeatPassword(rule, value, callback) {
      if (value !== this.form.password) {
        callback(new Error(this.$t("new_and_repeat_password_must_match")));
      } else {
        callback();
      }
    },
    validateForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const schema = Yup.object().shape({
              old_password: Yup.string().required(
                this.$t("old_password_required")
              ),
              password: Yup.string()
                .required(this.$t("new_password_required"))
                .min(8, this.$t("password_must_be_at_least"))
                .matches(
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*()!])/,
                  this.$t("password_must_contain")
                )
                .test(
                  "complexity",
                  this.$t("password_must_contain"),
                  (value) => {
                    const complexityRegex =
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*()!])/;
                    return complexityRegex.test(value);
                  }
                )
                .notOneOf(
                  [Yup.ref("old_password")],
                  this.$t("old_and_new_password_must_be_different")
                ),
              password_confirmation: Yup.string()
                .required(this.$t("repeat_password_required"))
                .oneOf(
                  [Yup.ref("password")],
                  this.$t("new_and_repeat_password_must_match")
                ),
            });

            await schema.validate(this.form, { abortEarly: false });

            this.errors = {};

            //console.log("form before sending:", this.form);
            this.errorMessage = "";
            // for testing
            // updatePassword(instance, {
            //   old_password:"123",
            //   password: "123",
            //   password_confirmation: "456",
            //   // user_id: "",
            // })
            this.saving = true;
            updatePassword(instance, this.form)
              .then((response) => {
                // console.log("updatePassword response: ", response);
                this.$store.commit("setPasswordExpired", false);
                this.showSuccessNotification();
              })
              .catch((error) => {
                this.errorMessage = this.constructErrorMessage(error);
                // for testing
                // this.showSuccessNotification();
                //this.errorMessage = error.response.data.errors.old_password[0];
                //console.error(error);
                //console.log("error:", error.response.data.errors.old_password[0])
              })
              .finally(() => {
                this.saving = false;
              });
          } catch (validationError) {
            const errors = {};

            validationError.inner.forEach((error) => {
              errors[error.path] = error.message;
            });

            this.errors = errors;
          }
        } else {
          // Validation errors exist, handle it accordingly
        }
      });
    },
    submitPasswordChange() {
      // console.log('Submit Password Change')
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const schema = Yup.object().shape({
              password: Yup.string()
                .required(this.$t("new_password_required"))
                .min(8, this.$t("password_must_be_at_least"))
                .matches(
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*()!])/,
                  this.$t("password_must_contain")
                )
                .test(
                  "complexity",
                  this.$t("password_must_contain"),
                  (value) => {
                    const complexityRegex =
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*()!])/;
                    return complexityRegex.test(value);
                  }
                )
                .notOneOf(
                  [Yup.ref("old_password")],
                  this.$t("old_and_new_password_must_be_different")
                ),
              password_confirmation: Yup.string()
                .required(this.$t("repeat_password_required"))
                .oneOf(
                  [Yup.ref("password")],
                  this.$t("new_and_repeat_password_must_match")
                ),
            });

            await schema.validate(this.form, { abortEarly: false });

            this.errors = {};

            // console.log("form before sending:", this.form);
            this.errorMessage = "";
            // Hardcoded example for testing
            // firstPasswordChange(instance, {
            //   password: "123",
            //   password_confirmation: "456",
            //   // user_id: "",
            // })

            this.saving = true;
            firstPasswordChange(instance, this.form)
              .then((response) => {
                // console.log("firstChangePassword response: ", response);
                this.$store.commit("setShowChangePasswordModal", false);
                this.$store.commit("setPasswordExpired", false);
                this.showSuccessNotification();
              })
              .catch((error) => {
                this.errorMessage = this.constructErrorMessage(error);
                // for testing
                // this.showSuccessNotification();
                // console.log('showNewSuccessNotification', this.showSuccessNotification)
                //this.errorMessage = error.response.data.errors.old_password[0];
                //console.error(error);
                //console.log("error:", error.response.data.errors.old_password[0])
              })
              .finally(() => {
                this.saving = false;
              });
          } catch (validationError) {
            const errors = {};

            validationError.inner.forEach((error) => {
              errors[error.path] = error.message;
            });

            this.errors = errors;
          }
        } else {
          // Validation errors exist, handle it accordingly
        }
      });
    },
  },
};
